'use strict';
import {TaskType} from '../tasks/enums/TaskType';
import {assetTasksStates} from '../tasks/router-config';
import {TASK_STATE_HELPER} from '../tasks/TASK_STATE_HELPER';
import fileActivityFeedTemplate from './ngTemplates/asset-file-requirements-activity-feed.html';
import requirementsFileTemplate from './ngTemplates/asset-requirements-files-details.html';
import {assetFileRequirementStates} from './router-config';


export const assetRequirementCtrlConfig = {
  taskType: TaskType.ASSET,
  modelDomain: 'AssetTaskDomain',
  taskListState: assetTasksStates.tasks,
  taskDetailsState: assetTasksStates.requirements,
};

routerAssetFileRequirementsProvider.$inject = [
  '$stateProvider',
];

export function routerAssetFileRequirementsProvider($stateProvider) {
  $stateProvider
    .state(assetFileRequirementStates.details, {
      title: 'requirements.views.files.title',
      url: '/tasks/requirements/:requirementId/files',
      views: {
        'tab-assets-tasks': {
          template: requirementsFileTemplate,
          controller: 'RequirementsFilesDetailsController',
        },
      },
      resolve: {
        requirement: TASK_STATE_HELPER.createResolveRequirement(
          'AssetFileRequirementDomain',
          assetRequirementCtrlConfig.taskListState,
        ),
        ctrlConfig: () => assetRequirementCtrlConfig,
      },
    })

    .state(assetFileRequirementStates.activityFeed, {
      title: 'requirements.views.activity.title',
      url: '/tasks/requirements/:requirementId/files-activity-feed',
      views: {
        'tab-assets-tasks': {
          template: fileActivityFeedTemplate,
        },
      },
      resolve: {
        ctrlConfig: () => assetRequirementCtrlConfig,
      },
    });
}



// WEBPACK FOOTER //
// ./src/js/requirements/router-asset-file-requirements.js